module.exports = __webpack_public_path__ + "static/media/3x2.ade33757.svg";